<template>
    <div class="modal show fitbase-modal-registration-flow" @click.self="requestClose">
        <div class="modal-dialog">
            <div class="modal-content fitbase-srfm">
            <!-- Header -->
            <div class="fitbase-srfm__header">
                <button v-if="currentView === 'item-detail'" class="fitbase-srfm__back-btn" @click="currentView = 'catalog'">
                    <svg width="8" height="14" viewBox="0 0 8 14" fill="none">
                        <path d="M7 1L1 7L7 13" stroke="#333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <span v-else style="width:28px;flex-shrink:0"></span>
                <span class="fitbase-srfm__header-title">Запись на занятие</span>
                <button class="fitbase-srfm__close-btn" @click="requestClose">
                    <span class="fitbase-icon-primary" :style="iconMask(closeIcon)" style="width:16px;height:16px;display:block"></span>
                </button>
            </div>

            <!-- Tabs -->
            <div class="fitbase-srfm__tabs">
                <div class="fitbase-srfm__tab fitbase-srfm__tab--active">
                    Выбор услуги
                </div>
                <div
                    class="fitbase-srfm__tab"
                    :class="{ 'fitbase-srfm__tab--active': activeTab === 'payment' || activeTab === 'profile' }"
                >
                    Оплата
                </div>
                <div
                    v-if="showProfileTab"
                    class="fitbase-srfm__tab"
                    :class="{ 'fitbase-srfm__tab--active': activeTab === 'profile' }"
                >
                    О себе
                </div>
            </div>

            <!-- Content -->
            <div class="fitbase-srfm__content">

                <!-- ======================== TAB: CATALOG ======================== -->
                <template v-if="activeTab === 'catalog'">

                    <!-- Item detail inline view -->
                    <template v-if="currentView === 'item-detail'">
                        <div v-if="detailLoading" class="fitbase-srfm__loading">
                            <span class="fitbase-loader loader-spin"></span>
                        </div>

                        <div v-else-if="viewingItem" class="fitbase-srfm__detail">


                            <!-- Название + время + описание -->
                            <div class="fitbase-srfm__detail-header">
                                <div class="fitbase-srfm__detail-name">{{ viewingItem.name }}</div>
                                <div v-if="viewingItem.time" class="fitbase-srfm__detail-time">
                                  <i><img src="../assets/img/calendar.svg" alt="" class="fitbase-srfm__detail-time-icon"></i>
                                  <span>{{ viewingItem.time }}</span>
                                </div>
                                <div v-if="viewingItem.description" class="fitbase-srfm__detail-description">{{ viewingItem.description }}</div>
                            </div>

                            <!-- Доступные занятия -->
                            <template v-if="detailSchedules(viewingItem).length">
                                <div class="fitbase-srfm__detail-section-title">Доступные занятия</div>
                                <div class="fitbase-srfm__detail-tags">
                                    <span
                                        v-for="(s, i) in detailSchedules(viewingItem)"
                                        v-show="schedulesExpanded || i < 5"
                                        :key="s.id"
                                        class="fitbase-srfm__detail-tag"
                                    >{{ s.name }}</span>
                                    <button
                                        v-if="!schedulesExpanded && detailSchedules(viewingItem).length > 5"
                                        class="fitbase-srfm__detail-tag fitbase-srfm__detail-tag--more"
                                        @click="schedulesExpanded = true"
                                    >Ещё {{ detailSchedules(viewingItem).length - 5 }}</button>
                                </div>
                            </template>

                            <!-- Филиалы -->
                            <template v-if="detailClubs(viewingItem).length">
                                <div class="fitbase-srfm__detail-section-title">Филиалы</div>
                                <div class="fitbase-srfm__detail-tags">
                                    <span v-for="c in detailClubs(viewingItem)" :key="c.id" class="fitbase-srfm__detail-tag">
                                        <span class="fitbase-srfm__detail-tag-icon fitbase-icon-primary" :style="iconMask(locationIcon)"></span>
                                        {{ c.name || c.address }}
                                    </span>
                                </div>
                            </template>

                            <!-- Характеристики -->
                            <div class="fitbase-srfm__detail-rows">
                                <div class="fitbase-srfm__detail-row" v-if="detailVisits(viewingItem)">
                                    <span class="fitbase-srfm__detail-row-key">Посещений</span>
                                    <span class="fitbase-srfm__detail-row-val">{{ detailVisits(viewingItem) }}</span>
                                </div>
                                <div class="fitbase-srfm__detail-row" v-if="detailDuration(viewingItem)">
                                    <span class="fitbase-srfm__detail-row-key">Период</span>
                                    <span class="fitbase-srfm__detail-row-val">{{ detailDuration(viewingItem) }}</span>
                                </div>
                                <div class="fitbase-srfm__detail-row" v-if="viewingItem.freeze_days > 0">
                                    <span class="fitbase-srfm__detail-row-key">Заморозка</span>
                                    <span class="fitbase-srfm__detail-row-val">{{ plural(viewingItem.freeze_days, ['день', 'дня', 'дней']) }}</span>
                                </div>
                                <div class="fitbase-srfm__detail-row" v-if="viewingItem.guest > 0">
                                    <span class="fitbase-srfm__detail-row-key">Гостевые визиты</span>
                                    <span class="fitbase-srfm__detail-row-val">{{ viewingItem.guest }} шт.</span>
                                </div>
                            </div>

                            <!-- Услуги, включённые в пакет -->
                            <template v-if="detailIncludedServices(viewingItem).length">
                                <div class="fitbase-srfm__detail-section-title">Услуги, включенные в пакет</div>
                                <div class="fitbase-srfm__detail-tags">
                                    <span v-for="s in detailIncludedServices(viewingItem)" :key="s.id || s.name" class="fitbase-srfm__detail-tag">
                                        {{ s.name || s }}
                                    </span>
                                </div>
                            </template>

                            <!-- Стоимость -->
                            <div class="fitbase-srfm__detail-price-row">
                                <span class="fitbase-srfm__detail-price-label">Стоимость</span>
                                <span class="fitbase-srfm__detail-price-value">
                                    <span v-if="viewingItem.sale_price && viewingItem.price_full && viewingItem.sale_price.value !== viewingItem.price_full.value" class="fitbase-srfm__detail-price-old">
                                        <currency-symbol :price="viewingItem.price_full" />
                                    </span>
                                    <span class="fitbase-srfm__detail-price-new"><currency-symbol :price="viewingItem.sale_price || viewingItem.price_full" /></span>
                                </span>
                            </div>

                            <button class="fitbase-srfm__pay-btn" @click="goToPayment(viewingItem)">
                                Оплатить <currency-symbol :price="viewingItem.sale_price || viewingItem.price_full" />
                            </button>
                        </div>
                    </template>

                    <!-- Catalog list view -->
                    <template v-else>
                        <div v-if="catalogLoading" class="fitbase-srfm__loading">
                            <span class="fitbase-loader loader-spin"></span>
                        </div>
                        <template v-else>

                        <!-- Мои абонементы и услуги -->
                        <div v-if="reasons.length > 0" class="fitbase-srfm__section">
                            <div class="fitbase-srfm__section-header" @click="toggleSection('myReasons')">
                                <span class="fitbase-srfm__section-title">Мои абонементы и услуги</span>
                                <svg class="fitbase-srfm__chevron" :class="{ 'fitbase-srfm__chevron--open': isSectionOpen('myReasons') }" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 7L6 2L11 7" stroke="#555" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div v-show="isSectionOpen('myReasons')" class="fitbase-srfm__items">
                                <div
                                    v-for="reason in reasons"
                                    :key="reason.id"
                                    class="fitbase-srfm__item"
                                    @click="selectReason(reason)"
                                >
                                    <div class="fitbase-srfm__item-stripe"></div>
                                    <div class="fitbase-srfm__item-info">
                                        <div class="fitbase-srfm__item-row">
                                            <div class="fitbase-srfm__item-name">{{ reason.name }}</div>
                                            <div class="fitbase-srfm__item-price fitbase-srfm__item-price--paid">Оплачено</div>
                                        </div>
                                        <div v-if="reason.description" class="fitbase-srfm__item-desc">{{ reason.description }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Promotions -->
                        <div v-if="promotionItems.length > 0" class="fitbase-srfm__section">
                            <div class="fitbase-srfm__section-header">
                                <span class="fitbase-srfm__section-title">Акции</span>
                                <div class="fitbase-srfm__section-nav">
                                    <button class="fitbase-srfm__nav-btn" @click="scrollPromos(-1)">
                                        <span class="fitbase-icon-primary" :style="iconMask(leftIcon)" style="width:16px;height:16px;display:block"></span>
                                    </button>
                                    <button class="fitbase-srfm__nav-btn" @click="scrollPromos(1)">
                                        <span class="fitbase-icon-primary" :style="iconMask(rightIcon)" style="width:16px;height:16px;display:block"></span>
                                    </button>
                                </div>
                            </div>
                            <div class="fitbase-srfm__promos-scroll" ref="promosScroll">
                                <div
                                    v-for="item in promotionItems"
                                    :key="item.id + '-' + item.item_type"
                                    class="sale_item"
                                    :style="{ backgroundImage: getSaleBackground(item) }"
                                    @click="openItemDetail(item)"
                                >
                                    <div class="sale_item_header">
                                        <div class="sale_item_title">{{ item.name }}</div>
                                        <div class="sale_item_price">
                                            <div class="sale_item_price-old"><currency-symbol :price="item.price" /></div>
                                            <div class="sale_item_price-new"><currency-symbol :price="item.price_to_pay" /></div>
                                        </div>
                                    </div>
                                    <div class="sale_item_description">{{ item.description_promotion }}</div>
                                </div>
                            </div>
                        </div>

                        <!-- Абонементы (contracts) -->
                        <div v-if="contractGroups.length > 0" class="fitbase-srfm__section fitbase-srfm__section--root">
                            <div class="fitbase-srfm__section-header" @click="toggleSection('contracts')">
                                <span class="fitbase-srfm__section-title">Абонементы</span>
                                <svg class="fitbase-srfm__chevron" :class="{ 'fitbase-srfm__chevron--open': isSectionOpen('contracts') }" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 7L6 2L11 7" stroke="#555" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div v-show="isSectionOpen('contracts')">
                                <template v-for="group in contractGroups" :key="'c_' + group.category_name">
                                    <div v-if="contractGroups.length > 1" class="fitbase-srfm__section fitbase-srfm__section--sub">
                                        <div class="fitbase-srfm__section-header fitbase-srfm__section-header--sub" @click="toggleSection('c_' + group.category_name)">
                                            <span class="fitbase-srfm__section-title fitbase-srfm__section-title--sub">{{ group.category_name }}</span>
                                            <svg class="fitbase-srfm__chevron" :class="{ 'fitbase-srfm__chevron--open': isSectionOpen('c_' + group.category_name) }" width="10" height="7" viewBox="0 0 12 8" fill="none">
                                                <path d="M1 7L6 2L11 7" stroke="#aaa" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                        </div>
                                        <div v-show="isSectionOpen('c_' + group.category_name)" class="fitbase-srfm__items">
                                            <div v-for="item in group.items" :key="item.id" class="fitbase-srfm__item" @click="openItemDetail(item)">
                                                <div class="fitbase-srfm__item-stripe"></div>
                                                <div class="fitbase-srfm__item-info">
                                                    <div class="fitbase-srfm__item-row">
                                                        <div class="fitbase-srfm__item-name">{{ item.name }}</div>
                                                        <div class="fitbase-srfm__item-price">
                                                            <span v-if="hasSale(item)" class="fitbase-srfm__item-price-old"><currency-symbol :price="item.price" /></span>
                                                            <currency-symbol :price="item.price_to_pay" />
                                                        </div>
                                                    </div>
                                                    <div v-if="getItemDesc(item)" class="fitbase-srfm__item-desc">{{ getItemDesc(item) }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-else>
                                        <div class="fitbase-srfm__items">
                                            <div v-for="item in group.items" :key="item.id" class="fitbase-srfm__item" :class="{ 'fitbase-srfm__item--has-badge': item.badge }" @click="openItemDetail(item)">
                                                <span v-if="item.badge" class="fitbase-srfm__item-badge" :class="`badge-${item.badge.color}`">{{ item.badge.text }}</span>
                                                <div class="fitbase-srfm__item-stripe" :style="item.view_settings?.background_color ? { background: item.view_settings.background_color } : {}"></div>
                                                <div class="fitbase-srfm__item-info">
                                                    <div class="fitbase-srfm__item-row">
                                                        <div class="fitbase-srfm__item-name">{{ item.name }}</div>
                                                        <div class="fitbase-srfm__item-price">
                                                            <span v-if="hasSale(item)" class="fitbase-srfm__item-price-old"><currency-symbol :price="item.price" /></span>
                                                            <currency-symbol :price="item.price_to_pay" />
                                                        </div>
                                                    </div>
                                                    <div v-if="getItemDesc(item)" class="fitbase-srfm__item-desc">{{ getItemDesc(item) }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>

                        <!-- Услуги (services) -->
                        <div v-if="serviceGroups.length > 0" class="fitbase-srfm__section fitbase-srfm__section--root">
                            <div class="fitbase-srfm__section-header" @click="toggleSection('services')">
                                <span class="fitbase-srfm__section-title">Услуги</span>
                                <svg class="fitbase-srfm__chevron" :class="{ 'fitbase-srfm__chevron--open': isSectionOpen('services') }" width="12" height="8" viewBox="0 0 12 8" fill="none">
                                    <path d="M1 7L6 2L11 7" stroke="#555" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div v-show="isSectionOpen('services')">
                                <template v-for="group in serviceGroups" :key="'s_' + group.category_name">
                                    <div v-if="serviceGroups.length > 1" class="fitbase-srfm__section fitbase-srfm__section--sub">
                                        <div class="fitbase-srfm__section-header fitbase-srfm__section-header--sub" @click="toggleSection('s_' + group.category_name)">
                                            <span class="fitbase-srfm__section-title fitbase-srfm__section-title--sub">{{ group.category_name }}</span>
                                            <svg class="fitbase-srfm__chevron" :class="{ 'fitbase-srfm__chevron--open': isSectionOpen('s_' + group.category_name) }" width="10" height="7" viewBox="0 0 12 8" fill="none">
                                                <path d="M1 7L6 2L11 7" stroke="#aaa" stroke-width="1.5" stroke-linecap="round"/>
                                            </svg>
                                        </div>
                                        <div v-show="isSectionOpen('s_' + group.category_name)" class="fitbase-srfm__items">
                                            <div v-for="item in group.items" :key="item.id" class="fitbase-srfm__item" @click="openItemDetail(item)">
                                                <div class="fitbase-srfm__item-stripe"></div>
                                                <div class="fitbase-srfm__item-info">
                                                    <div class="fitbase-srfm__item-row">
                                                        <div class="fitbase-srfm__item-name">{{ item.name }}</div>
                                                        <div class="fitbase-srfm__item-price">
                                                            <span v-if="hasSale(item)" class="fitbase-srfm__item-price-old"><currency-symbol :price="item.price" /></span>
                                                            <currency-symbol :price="item.price_to_pay" />
                                                        </div>
                                                    </div>
                                                    <div v-if="getItemDesc(item)" class="fitbase-srfm__item-desc">{{ getItemDesc(item) }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <template v-else>
                                        <div class="fitbase-srfm__items">
                                            <div v-for="item in group.items" :key="item.id" class="fitbase-srfm__item" :class="{ 'fitbase-srfm__item--has-badge': item.badge }" @click="openItemDetail(item)">
                                                <span v-if="item.badge" class="fitbase-srfm__item-badge" :class="`badge-${item.badge.color}`">{{ item.badge.text }}</span>
                                                <div class="fitbase-srfm__item-stripe" :style="item.view_settings?.background_color ? { background: item.view_settings.background_color } : {}"></div>
                                                <div class="fitbase-srfm__item-info">
                                                    <div class="fitbase-srfm__item-row">
                                                        <div class="fitbase-srfm__item-name">{{ item.name }}</div>
                                                        <div class="fitbase-srfm__item-price">
                                                            <span v-if="hasSale(item)" class="fitbase-srfm__item-price-old"><currency-symbol :price="item.price" /></span>
                                                            <currency-symbol :price="item.price_to_pay" />
                                                        </div>
                                                    </div>
                                                    <div v-if="getItemDesc(item)" class="fitbase-srfm__item-desc">{{ getItemDesc(item) }}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </template>
                            </div>
                        </div>

                        <div v-if="catalogError" class="fitbase-srfm__payment-errors">
                            <div class="fitbase-srfm__payment-error">{{ catalogError }}</div>
                        </div>

                        <!-- Empty -->
                        <div v-if="isCatalogEmpty" class="fitbase-srfm__empty">
                            Подходящие услуги не найдены
                        </div>
                        </template>
                    </template>
                </template>

                <!-- ======================== TAB: PAYMENT ======================== -->
                <template v-if="activeTab === 'payment'">
                    <!-- Loading overlay -->
                    <div v-if="paymentLoading || atmosWait.active" class="fitbase-srfm__loading">
                        <template v-if="atmosWait.active">
                            <span v-if="!atmosWait.timedOut" class="fitbase-loader loader-spin"></span>
                            <div style="margin-top:12px;font-size:14px;color:#555;text-align:center">
                                <template v-if="!atmosWait.timedOut">
                                    Оплата открыта в новой вкладке. Ожидаем результат…
                                </template>
                                <template v-else>
                                    Не удалось подтвердить оплату. Если вы уже оплатили в открытой вкладке, проверьте статус ещё раз.
                                </template>
                            </div>
                            <button type="button" class="fitbase-srfm__pay-btn" style="margin-top:16px" @click="retryAtmosCheck">
                                Проверить оплату ещё раз
                            </button>
                            <button v-if="atmosWait.timedOut" type="button" class="fitbase-srfm__link-btn" @click="reopenAtmosTab">
                                Открыть страницу оплаты ещё раз
                            </button>
                            <button type="button" class="fitbase-srfm__link-btn" @click="cancelAtmosWait">
                                Отменить
                            </button>
                        </template>
                        <template v-else>
                            <span class="fitbase-loader loader-spin"></span>
                            <div style="margin-top:12px;font-size:14px;color:#555;text-align:center">
                                Производится оплата. Не закрывайте это окно
                            </div>
                        </template>
                    </div>

                    <template v-else>
                        <!-- Item summary -->
                        <div class="fitbase-srfm__payment-summary" v-if="selectedItem">
                            <div class="fitbase-srfm__payment-summary-name">{{ selectedItem.name }}</div>
                            <div v-if="getItemDesc(selectedItem)" class="fitbase-srfm__payment-summary-desc">{{ getItemDesc(selectedItem) }}</div>
                        </div>

                        <!-- Payment type dropdown -->
                        <div class="fitbase-srfm__payment-type-select" :class="{ active: paymentSelectOpen }" tabindex="0" @blur="paymentSelectOpen = false">
                            <div class="fitbase-srfm__select-value" @click="paymentSelectOpen = !paymentSelectOpen">
                                <div class="fitbase-srfm__select-current" v-if="form.payment_type">
                                    <img
                                        :src="paymentIconSrc(form.payment_type.icon)"
                                        alt=""
                                        class="fitbase-srfm__select-icon"
                                    >
                                    <span>{{ form.payment_type.label }}</span>
                                    <span v-if="form.payment_type.card" class="fitbase-srfm__select-card">*{{ form.payment_type.card.CardLastFour }}</span>
                                </div>
                                <div v-else class="fitbase-srfm__select-placeholder">Выберите способ оплаты</div>
                                <svg class="fitbase-srfm__select-arrow" width="10" height="6" viewBox="0 0 10 6" fill="none">
                                    <path d="M1 1L5 5L9 1" stroke="#3C67D6" stroke-width="1.5" stroke-linecap="round"/>
                                </svg>
                            </div>
                            <div class="fitbase-srfm__select-items" v-show="paymentSelectOpen">
                                <div
                                    v-for="(option, i) in paymentTypes"
                                    :key="i"
                                    class="fitbase-srfm__select-item"
                                    :class="{ active: form.payment_type === option }"
                                    @click="form.payment_type = option; paymentSelectOpen = false"
                                >
                                    <img
                                        :src="paymentIconSrc(option.icon)"
                                        alt=""
                                        class="fitbase-srfm__select-icon"
                                    >
                                    <span>{{ option.label }}</span>
                                    <span v-if="option.card" class="fitbase-srfm__select-card">*{{ option.card.CardLastFour }}</span>
                                    <svg v-if="form.payment_type === option" style="margin-left:auto;flex-shrink:0" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.47173 9.52876L12.667 3.3335L13.6098 4.27631L6.47173 11.4144L2.66699 7.60964L3.6098 6.66683L6.47173 9.52876Z" fill="#3C67D6"/>
                                    </svg>
                                </div>
                            </div>
                        </div>

                        <!-- Promo code -->
                        <div class="fitbase-srfm__promo-field" :class="{ 'fitbase-srfm__promo-field--error': promocodeData.success === false }">
                            <input
                                type="text"
                                placeholder="Промокод"
                                v-model.trim="form.promocode"
                                class="fitbase-srfm__promo-input"
                            >
                            <button class="fitbase-srfm__promo-apply" @click="checkPromocode">Применить</button>
                        </div>
                        <div class="fitbase-srfm__promo-error" v-if="promocodeData.error">{{ promocodeData.error }}</div>

                        <!-- Receipt email toggle -->
                        <template v-if="!showYandexPaySplitWidget">
                            <div class="fitbase-srfm__receipt-row">
                                <span class="fitbase-srfm__receipt-label">Получить чек на почту</span>
                                <button
                                    class="fitbase-srfm__toggle"
                                    :class="{ 'fitbase-srfm__toggle--on': form.wantReceipt }"
                                    @click="form.wantReceipt = !form.wantReceipt"
                                    type="button"
                                >
                                    <span class="fitbase-srfm__toggle-knob"></span>
                                </button>
                            </div>
                            <div v-if="form.wantReceipt" class="fitbase-srfm__email-field">
                                <input
                                    type="email"
                                    placeholder="Электронная почта для чека"
                                    v-model.trim="form.email"
                                    class="fitbase-srfm__profile-input"
                                >
                            </div>
                        </template>

                        <!-- Deposit/bonus toggle -->
                        <div
                            class="fitbase-srfm__receipt-row fitbase-srfm__receipt-row--two-line"
                            v-if="$store.getters.settings?.modules?.balance?.enable && depositData?.value > 0"
                        >
                            <div class="fitbase-srfm__receipt-label-wrap">
                                <span class="fitbase-srfm__receipt-label">{{ depositData.value }} фитрублей</span>
                                <span class="fitbase-srfm__receipt-sublabel">Оплатить бонусами <currency-symbol :price="usableDeposit" /></span>
                            </div>
                            <button
                                class="fitbase-srfm__toggle"
                                :class="{ 'fitbase-srfm__toggle--on': form.useDeposit }"
                                @click="form.useDeposit = !form.useDeposit"
                                type="button"
                            >
                                <span class="fitbase-srfm__toggle-knob"></span>
                            </button>
                        </div>

                        <!-- Total -->
                        <div class="fitbase-srfm__total">
                            <div class="fitbase-srfm__total-row" v-if="form.useDeposit && usableDeposit.value > 0">
                                <span class="fitbase-srfm__total-key fitbase-srfm__total-key--small">Фитрубли</span>
                                <span class="fitbase-srfm__total-val fitbase-srfm__total-val--small fitbase-srfm__total-val--red">-<currency-symbol :price="usableDeposit" /></span>
                            </div>
                            <div class="fitbase-srfm__total-row" v-if="promocodeData.success && usablePromocode && usablePromocode.value !== 0">
                                <span class="fitbase-srfm__total-key fitbase-srfm__total-key--small">Скидка по промокоду</span>
                                <span class="fitbase-srfm__total-val fitbase-srfm__total-val--small fitbase-srfm__total-val--red">-<currency-symbol :price="usablePromocode" /></span>
                            </div>
                            <div class="fitbase-srfm__total-row">
                                <span class="fitbase-srfm__total-key">Итого</span>
                                <span class="fitbase-srfm__total-val"><currency-symbol :price="priceTotal" /></span>
                            </div>
                        </div>

                        <YandexPaySplitWidget
                            v-if="showYandexPaySplitWidget"
                            :amount="priceTotal.value"
                            :currency="priceTotal.currency"
                        />

                        <!-- Timer -->
                        <div v-if="hasTimer" class="fitbase-srfm__timer">
                            <span class="fitbase-srfm__timer-text">Успейте оплатить, чтобы подтвердить бронь</span>
                            <span class="fitbase-srfm__timer-badge">{{ timerDisplay }}</span>
                        </div>

                        <!-- Errors -->
                        <div v-if="paymentErrors.length" class="fitbase-srfm__payment-errors">
                            <div v-for="err in paymentErrors" :key="err" class="fitbase-srfm__payment-error">{{ err }}</div>
                        </div>

                        <!-- Pay button -->
                        <button
                            class="fitbase-srfm__pay-btn"
                            :disabled="paymentLoading || timerExpired"
                            @click="submitPayment"
                        >
                            Оплатить <currency-symbol :price="priceTotal" />
                        </button>

                        <!-- Offer hint -->
                        <div class="fitbase-srfm__offer-hint">
                          Нажимая на кнопку, Вы соглашаетесь с
                          <a :href="offerLink" target="_blank">Договором оферты</a>
                        </div>
                    </template>
                </template>

                <!-- ======================== TAB: PROFILE ======================== -->
                <template v-if="activeTab === 'profile'">
                    <div class="fitbase-login_form update_user_form">
                        <p class="personal_data">Ваши личные данные</p>
                        <input
                            type="text"
                            placeholder="Имя"
                            v-model.trim="profileForm.name"
                        >
                        <input
                            type="text"
                            placeholder="Фамилия"
                            v-model.trim="profileForm.surname"
                        >
                        <Datepicker
                            v-model="profileForm.b_day"
                            modelType="yyyy-MM-dd"
                            placeholder="Дата рождения"
                            format="dd.MM.yyyy"
                            locale="ru"
                            cancelText=""
                            selectText="Применить"
                            :enableTimePicker="false"
                            :disabledDates="(date) => date >= new Date()"
                        />
                        <div class="fitbase-srfm__sex-btns">
                            <button
                                type="button"
                                class="fitbase-srfm__sex-btn"
                                :class="{ 'fitbase-srfm__sex-btn--active': profileForm.sex === 'мужской' }"
                                @click="profileForm.sex = 'мужской'"
                            >
                                Мужчина
                            </button>
                            <button
                                type="button"
                                class="fitbase-srfm__sex-btn"
                                :class="{ 'fitbase-srfm__sex-btn--active': profileForm.sex === 'женский' }"
                                @click="profileForm.sex = 'женский'"
                            >
                                Женщина
                            </button>
                        </div>
                        <div v-if="profileLoading" style="text-align:center;padding:8px 0">
                            <span class="fitbase-loader loader-spin"></span>
                        </div>
                        <button
                            v-else
                            class="btn btn-full"
                            :class="{ disabled: !profileForm.name }"
                            :disabled="!profileForm.name"
                            @click="submitProfile"
                        >
                            Зарегистрироваться
                        </button>

                    </div>
                    <div class="fitbase-srfm__fitbase-footer">
                      <a href="https://fitbase.io/?utm_source=widget&utm_campaign=group_schedule" target="_blank" rel="noopener">
                        <span class="fitbase-footer-logo"></span>
                      </a>
                    </div>
                </template>

            </div>
        </div>
        </div>
    </div>

    <!-- Timer-expired overlay -->
    <div v-if="timerExpired && !atmosWait.active" class="srfm-overlay fitbase-srfm-overlay--top">
        <div class="fitbase-srfm fitbase-srfm--alert">
            <button class="fitbase-srfm__close-btn fitbase-srfm__close-btn--abs" @click="$emit('close')">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M2 2L14 14M14 2L2 14" stroke="#333" stroke-width="1.8" stroke-linecap="round"/>
                </svg>
            </button>
            <div class="fitbase-srfm__alert-icon fitbase-srfm__alert-icon--warn">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M16 3L2 28H30L16 3Z" stroke="#FF6B35" stroke-width="2" stroke-linejoin="round" fill="none"/>
                    <path d="M16 13V19" stroke="#FF6B35" stroke-width="2" stroke-linecap="round"/>
                    <circle cx="16" cy="23" r="1.2" fill="#FF6B35"/>
                </svg>
            </div>
            <h3 class="fitbase-srfm__alert-title">Запись отменена</h3>
            <p class="fitbase-srfm__alert-text">Мы не получили оплату, поэтому запись была отменена. Свяжитесь с администратором или запишитесь снова</p>
            <button class="fitbase-srfm__pay-btn" @click="restartFlow">Записаться</button>
            <button class="fitbase-srfm__link-btn" @click="$emit('close')">Отмена</button>
        </div>
    </div>

    <!-- Close confirmation dialog -->
    <div v-if="showCloseConfirm" class="srfm-overlay fitbase-srfm-overlay--top">
        <div class="fitbase-srfm fitbase-srfm--alert">
            <div class="fitbase-srfm__alert-icon fitbase-srfm__alert-icon--close">
                <span class="fitbase-icon-primary" :style="iconMask(closeIcon)" style="width:16px;height:16px;display:block"></span>
            </div>
            <h3 class="fitbase-srfm__alert-title">Закрыть это окно?</h3>
            <p class="fitbase-srfm__alert-text">Введенные данные не сохранятся</p>
            <button class="fitbase-srfm__pay-btn" @click="confirmClose">Закрыть</button>
            <button class="fitbase-srfm__link-btn" @click="showCloseConfirm = false">Отмена</button>
        </div>
    </div>
</template>

<script>
import closeIcon from '../assets/img/close.svg'
import leftIcon from '../assets/img/left-blue.svg'
import rightIcon from '../assets/img/right-blue.svg'
import locationIcon from '../assets/img/location-blue.svg'
import {
    atmosRedirectPay,
    checkInvoiceWithRetry,
    cloudPaymentsPayWidget,
    createAtmosTabWaiter,
    getPaymentReturnUrl,
    openAtmosPopupTab,
    PAYMENT_SCOPE_PERSONAL_ACCOUNT,
    payselectionPayWidget,
    startYandexPayRedirect,
    tipTopPayWidget,
    yooKassaPayWidget,
    plural
} from '../utilities/index.js'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import YandexPaySplitWidget from './YandexPaySplitWidget.vue'
import CurrencySymbol from './CurrencySymbol.vue'

export default {
    name: 'ScheduleRegistrationFlowModal',
    components: { Datepicker, YandexPaySplitWidget, CurrencySymbol },
    props: {
        scheduleId:    { type: Number, required: true },
        showProfileTab: { type: Boolean, default: false },
        initialCatalog: { type: Array, default: () => [] },
        reasons:        { type: Array, default: () => [] },
    },
    emits: ['close', 'registered', 'insufficient-visits', 'restart'],
    data() {
        return {
            closeIcon,
            leftIcon,
            rightIcon,
            locationIcon,
            activeTab: 'catalog',
            currentView: 'catalog', // 'catalog' | 'item-detail'
            viewingItem: null,
            detailLoading: false,
            schedulesExpanded: false,
            selectedItem: null,

            // Payment
            apiKey: '',
            cards: [],
            paymentTypes: [],
            paymentSelectOpen: false,
            form: {
                payment_type: null,
                promocode: '',
                email: '',
                wantReceipt: false,
                useDeposit: false,
            },
            promocodeData: {
                success: null,
                error: null,
                discount_amount: null,
            },
            paymentLoading: false,
            paymentErrors: [],
            atmosWait: { active: false, timedOut: false },
            debtItem: null,
            registrationStatus: null,
            discountApplied: false,

            // Timer
            timerSeconds: 0,
            timerDeadline: null,
            timerInterval: null,
            timerExpired: false,

            // Close confirmation
            showCloseConfirm: false,

            // Catalog sections
            closedSections: { contracts: false, services: false },
            catalogLoading: false,
            catalogError: '',

            // Profile tab
            profileForm: {
                name: '',
                surname: '',
                b_day: null,
                sex: '',
            },
            profileLoading: false,
        }
    },
    computed: {
        tabProgressWidth() {
            const tabs = this.showProfileTab ? 3 : 2
            const idx = this.activeTab === 'catalog' ? 1
                : this.activeTab === 'payment' ? 2
                : 3
            return ((idx / tabs) * 100) + '%'
        },
        promotionItems() {
            const items = []
            for (const group of this.initialCatalog) {
                for (const item of group.items) {
                    if (item.enable_promotion) items.push(item)
                }
            }
            return items
        },
        contractGroups() {
            const items = this.initialCatalog.flatMap(group =>
                group.items.filter(i => i.item_type === 'contract')
            )
            return items.length ? [{ category_name: 'Абонементы', items }] : []
        },
        serviceGroups() {
            const items = this.initialCatalog.flatMap(group =>
                group.items.filter(i => i.item_type === 'service')
            )
            return items.length ? [{ category_name: 'Услуги', items }] : []
        },
        isCatalogEmpty() {
            return this.reasons.length === 0 && this.promotionItems.length === 0 && this.contractGroups.length === 0 && this.serviceGroups.length === 0
        },
        depositData() {
            return this.$store.getters.userDeposit || { value: 0, currency: 'RUB' }
        },
        itemPrice() {
            if (this.debtItem) {
                if (this.debtItem.full_sum) return this.debtItem.full_sum
                if (this.debtItem.sum_full) return this.debtItem.sum_full
            }
            if (!this.selectedItem) return { value: 0, currency: 'RUB' }
            if (this.selectedItem.price_full) {
                const sale = this.selectedItem.sale_price
                const full = this.selectedItem.price_full
                if (sale && sale.value !== full.value) return sale
                return full
            }
            const raw = this.selectedItem.price_to_pay
            if (raw && typeof raw === 'object') return raw
            return { value: raw || 0, currency: 'RUB' }
        },
        usablePromocode() {
            return this.promocodeData.discount_amount !== undefined && this.promocodeData.discount_amount !== null
                ? this.promocodeData.discount_amount
                : null
        },
        usableDeposit() {
            if (!this.depositData || this.depositData.value <= 0) return { value: 0, currency: 'RUB' }
            const promoDiscount = (this.promocodeData.success && this.usablePromocode) ? this.usablePromocode.value : 0
            const remaining = Math.max(0, this.itemPrice.value - promoDiscount)
            if (this.depositData.value > remaining) {
                return { value: remaining, currency: this.itemPrice.currency || 'RUB' }
            }
            return this.depositData
        },
        priceTotal() {
            let total = this.itemPrice.value
            if (this.form.useDeposit && this.usableDeposit) {
                total -= this.usableDeposit.value
            }
            if (this.usablePromocode && this.promocodeData.success) {
                total -= this.usablePromocode.value
            }
            if (total < 0) total = 0
            return { value: total, currency: this.itemPrice.currency || 'RUB' }
        },
        timerDisplay() {
            const m = Math.floor(this.timerSeconds / 60)
            const s = this.timerSeconds % 60
            return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0')
        },
        hasTimer() {
            return this.timerDeadline !== null
        },
        offerLink() {
            try {
                return this.$store.getters.documentsModules.offer.link || '#'
            } catch (e) {
                return '#'
            }
        },
        showYandexPaySplitWidget() {
            const paymentSettings = this.$store.getters.settings?.modules?.payment_types
            return paymentSettings?.online?.acquiring_integration_type === 'yandex_pay'
        },
    },
    methods: {
      plural,
        iconMask(src) {
            return { maskImage: `url(${src})`, webkitMaskImage: `url(${src})` }
        },
        paymentIconSrc(icon) {
            const known = ['cash', 'maestro', 'mastercard', 'mir', 'new_card', 'sbp', 'union', 'visa']
            const lc = (icon || '').toLowerCase().replace(/\s+/g, '_')
            const found = known.find(k => k === lc || lc.includes(k))
            return require('../assets/img/payment_types/' + (found || 'new_card') + '.png')
        },
        // ── Catalog helpers ──────────────────────────────────────────────
        isSectionOpen(key) {
            return this.closedSections[key] !== true
        },
        toggleSection(key) {
            this.closedSections = { ...this.closedSections, [key]: !this.closedSections[key] }
        },
        scrollPromos(dir) {
            const el = this.$refs.promosScroll
            if (el) el.scrollBy({ left: dir * 340, behavior: 'smooth' })
        },
        getSaleBackground(item) {
            const valid = ['blue', 'green', 'orange', 'pink', 'purple', 'red', 'black']
            const color = valid.includes(item.view_settings?.promo_color) ? item.view_settings.promo_color : 'blue'
            return 'url(' + require('../assets/img/contract_' + color + '.png') + ')'
        },
        async selectReason(reason) {
            this.catalogLoading = true
            this.catalogError = ''
            try {
                const params = {}
                if (reason.type === 'contract') {
                    params.client_contract_id = parseInt(reason.id.replace('contract_', ''))
                } else {
                    params.client_service_id = parseInt(reason.id.replace('service_', ''))
                }
                const resp = (await this.$api.schedule.postRegistration(this.scheduleId, params)).data
                if (resp.status === 'need_select_reason') {
                    this.$emit('insufficient-visits', 'Недостаточно посещений для записи. Приобретите абонемент или услугу')
                    return
                }

                if (this.showProfileTab) {
                    this.stopTimer()
                    this.activeTab = 'profile'
                } else {
                    this.$emit('registered', 'Вы записаны!')
                }
            } catch (e) {
                const errData = e.response && e.response.data
                this.catalogError = (errData && errData.message) || 'Ошибка при записи'
            } finally {
                this.catalogLoading = false
            }
        },
        getItemDesc(item) {
            const parts = []
            if (item.visits) parts.push(item.visits + ' посещений')
            if (item.duration) parts.push(item.duration)
            return parts.join(', ')
        },
        hasSale(item) {
            const price = item.price
            const priceToPay = item.price_to_pay
            const pv = price && typeof price === 'object' ? price.value : price
            const ppv = priceToPay && typeof priceToPay === 'object' ? priceToPay.value : priceToPay
            return pv && ppv && pv > ppv
        },
        async openItemDetail(item) {
            this.viewingItem = null
            this.detailLoading = true
            this.schedulesExpanded = false
            this.currentView = 'item-detail'
            try {
                let response
                if (item.item_type === 'contract') {
                    response = await this.$api.shop.getCatalogContract(item.id)
                } else {
                    response = await this.$api.shop.getCatalogService(item.id)
                }
                this.viewingItem = { ...response.data, item_type: item.item_type }
            } catch (e) {
                this.viewingItem = item
            } finally {
                this.detailLoading = false
            }
        },
        detailVisits(item) {
            const v = item.visits !== undefined ? item.visits : item.count
            if (v === null || v === undefined || v === '') return ''
            if (v === 0) return 'неограниченно'
            return v;
            //  return plural(v, ['посещение', 'посещения', 'посещений'])
        },
        detailDuration(item) {
            if (item.duration) return item.duration
            if (item.validity_period) return plural(item.validity_period, ['день', 'дня', 'дней'])
            return ''
        },
        detailSchedules(item) {
            return item.schedule_templates || item.schedule_template || []
        },
        detailClubs(item) {
            return item.clubs || item.branches || []
        },
        detailIncludedServices(item) {
            return item.included_services || item.services_in_pack || []
        },
        async goToPayment(item) {
            this.selectedItem = item
            this.viewingItem = null
            this.currentView = 'catalog'
            this.debtItem = null
            this.registrationStatus = null
            this.paymentErrors = []
            this.activeTab = 'payment'
            this.paymentLoading = true

            try {
                const params = {}
                if (item.item_type === 'contract') {
                    params.contract_id = item.id
                    if (item.reccurent && item.reccurent.enable === true) {
                        params.recurrent = 1
                    }
                } else {
                    params.service_id = item.id
                }
                const resp = (await this.$api.schedule.postRegistration(this.scheduleId, params)).data
                this.registrationStatus = resp.status
                this.debtItem = resp.debt_item || null

                if (resp.status === 'paid' || resp.status === 'success' || resp.status === 'need_cash_payment' || !this.debtItem) {
                    await this.finishRegistration()
                    return
                }
                const deadline = resp.registration_info && resp.registration_info.auto_delete_time
                this.startTimer(deadline ? deadline * 1000 : null)
            } catch (e) {
                const errData = e.response && e.response.data
                this.paymentErrors.push((errData && errData.message) || 'Не удалось создать запись на занятие')
            } finally {
                this.paymentLoading = false
            }
        },
        // ── Payment helpers ──────────────────────────────────────────────
        async loadPaymentData() {
            try {
                this.apiKey = (await this.$api.payment.getApiKey()).data
            } catch (e) { /* ignore */ }
            try {
                this.cards = (await this.$api.payment.getCards()).data
                this.buildPaymentTypes()
            } catch (e) { /* ignore */ }
        },
        buildPaymentTypes() {
            const types = []
            const settings = this.$store.getters.settings?.modules?.payment_types
            const integrationType = settings?.online?.acquiring_integration_type
            if (settings) {
                if (settings.online && settings.online.enable) {
                    // Яндекс Пэй на данный момент не поддерживает привязку карт — сохранённые карты не показываем
                    if (integrationType !== 'yandex_pay') {
                        this.cards.forEach(card => {
                            types.push({
                                method: 'card',
                                label: card.CardType,
                                icon: card.CardType,
                                card: card,
                            })
                        })
                    }
                    types.push({ method: 'new_card', label: 'Новая карта', icon: 'new_card' })
                }
            }
            this.paymentTypes = types
            if (types.length > 0) this.form.payment_type = types[0]
        },
        async checkPromocode() {
            if (!this.form.promocode || !this.selectedItem) return
            try {
                const result = (await this.$api.payment.promocode({
                    params: {
                        promocode: this.form.promocode,
                        service_id: this.selectedItem.item_type === 'service' ? this.selectedItem.id : null,
                        contract_id: this.selectedItem.item_type === 'contract' ? this.selectedItem.id : null,
                    }
                })).data
                this.promocodeData = result
                this.form.useDeposit = false
            } catch (e) {
                this.promocodeData = {
                    success: false,
                    error: e.response?.data?.error || 'Ошибка при применении промокода',
                    discount_amount: null,
                }
            }
        },
        startTimer(deadlineMs = null) {
            this.stopTimer()
            this.timerExpired = false
            this.timerSeconds = 0

            if (!deadlineMs || !Number.isFinite(deadlineMs)) {
                this.timerDeadline = null
                return
            }

            this.timerDeadline = deadlineMs
            if (deadlineMs <= Date.now()) {
                this.timerExpired = true
                return
            }

            const tick = () => {
                const remaining = Math.max(0, Math.ceil((this.timerDeadline - Date.now()) / 1000))
                this.timerSeconds = remaining
                if (remaining === 0) {
                    this.stopTimer()
                    this.timerExpired = true
                }
            }
            tick()
            if (!this.timerExpired) {
                this.timerInterval = setInterval(tick, 1000)
            }
        },
        restartFlow() {
            this.timerExpired = false
            this.timerSeconds = 0
            this.timerDeadline = null
            this.selectedItem = null
            this.viewingItem = null
            this.currentView = 'catalog'
            this.activeTab = 'catalog'
            this.paymentErrors = []
            this.debtItem = null
            this.registrationStatus = null
            this.form.promocode = ''
            this.form.useDeposit = false
            this.promocodeData = {
                success: null,
                error: null,
                discount_amount: null,
            }
            this.discountApplied = false
            this.$emit('restart')
        },
        stopTimer() {
            if (this.timerInterval) {
                clearInterval(this.timerInterval)
                this.timerInterval = null
            }
        },
        async retryAtmosCheck() {
            const result = await this.atmosWaiter.retry()
            if (result) {
                await this.finishRegistration()
            }
        },
        cancelAtmosWait() {
            this.atmosWaiter.cancel()
            this.paymentLoading = false
        },
        reopenAtmosTab() {
            this.atmosWaiter.reopen()
        },
        async createInvoice(debt_item) {
            const acquiringIntegrationType = this.$store.getters.settings?.modules?.payment_types?.online?.acquiring_integration_type
            // ATMOS: withoutLink=0 нужен только для оплаты новой (непривязанной) картой по ссылке — для
            // оплаты уже привязанной картой (method === 'card') pay-link не нужен и создавать его нельзя:
            // его invoice_id пересекается с invoice_id последующего chargeToken() ("-1 Внутренняя ошибка").
            const paymentMethod = this.form.payment_type ? this.form.payment_type.method : 'new_card'
            const isAtmosLinkPayment = acquiringIntegrationType === 'atmos' && paymentMethod !== 'card'
            return (await this.$api.payment.createInvoice({
                orders: debt_item.id,
                savecard: 1,
                email: this.form.email,
                cloudcheck: 1,
                withoutLink: isAtmosLinkPayment ? 0 : 1,
                returnUrl: getPaymentReturnUrl(),
            })).data
        },
        async pay(invoiceId, amount, currency, JsonData = {}, atmosPopup = null) {
            const paymentMethod = this.form.payment_type ? this.form.payment_type.method : 'new_card'
            let payResult = false

            if (paymentMethod === 'card') {
                const data = (await this.$api.payment.pay({
                    invoice_id: invoiceId,
                    card_id: this.form.payment_type.card.id,
                })).data
                payResult = data.success === true
            } else if (paymentMethod === 'new_card') {
                const settings = this.$store.getters.settings?.modules?.payment_types?.online?.acquiring_integration_type
                const userId = this.$store.getters.userId
                const email = this.form.email

                if (settings === 'cloud_payments') {
                    const key = this.apiKey && this.apiKey.key ? this.apiKey.key : this.apiKey
                    payResult = await cloudPaymentsPayWidget(key, invoiceId, amount, currency, userId, email, JsonData)
                } else if (settings === 'payselection') {
                    payResult = await payselectionPayWidget(invoiceId, amount, currency, userId, email, JsonData)
                } else if (settings === 'tip_top_pay') {
                    payResult = await tipTopPayWidget(invoiceId, amount, currency, userId, email, JsonData)
                } else if (settings === 'yookassa') {
                    payResult = await yooKassaPayWidget(invoiceId, JsonData)
                } else if (settings === 'yandex_pay') {
                    return startYandexPayRedirect(JsonData, {
                        scope: PAYMENT_SCOPE_PERSONAL_ACCOUNT,
                        invoiceId,
                        message: 'Вы успешно записаны!',
                    })
                } else if (settings === 'atmos') {
                    const atmosResult = atmosRedirectPay(invoiceId, JsonData, atmosPopup)
                    if (!atmosResult) {
                        return false
                    }
                    if (atmosResult.mode === 'redirect') {
                        return 'redirect'
                    }
                    return await this.atmosWaiter.start(
                        atmosResult.popup,
                        () => this.$api.payment.checkInvoice({ params: { save_card: 1, invoiceId } }),
                        JsonData.paymentLink
                    )
                } else {
                    console.log('unknown payment method - ', settings)
                    payResult = false
                }
            }

            if (payResult) {
                await checkInvoiceWithRetry(this.$api, invoiceId, 1)
            }

            return payResult
        },
        async submitPayment() {
            if (this.timerExpired || (this.hasTimer && this.timerSeconds <= 0)) {
                this.timerExpired = true
                return
            }

            if (!this.debtItem) {
                this.paymentErrors = ['Счёт для оплаты не найден. Попробуйте начать заново.']
                return
            }
            this.paymentLoading = true
            this.paymentErrors = []

            const acquiringIntegrationTypeAtClick = this.$store.getters.settings?.modules?.payment_types?.online?.acquiring_integration_type
            const willOpenAtmosTab = this.form.payment_type?.method === 'new_card' && acquiringIntegrationTypeAtClick === 'atmos'
            const atmosPopup = willOpenAtmosTab ? openAtmosPopupTab() : null
            let atmosPopupHandedOff = false

            try {
                let debtItem = this.debtItem

                const useDeposit = this.form.useDeposit && this.usableDeposit.value > 0
                const usePromocode = this.promocodeData.success === true && !!this.form.promocode
                if (!this.discountApplied && (useDeposit || usePromocode)) {
                    const payload = { debt_item_id: debtItem.id }
                    if (useDeposit) payload.deposit_amount = this.usableDeposit.value
                    if (usePromocode) payload.promocode = this.form.promocode
                    const result = (await this.$api.payment.payUseDeposit(payload)).data
                    if (!result || result.success !== true) {
                        this.paymentErrors.push('Не удалось применить скидку. Попробуйте ещё раз.')
                        return
                    }
                    this.discountApplied = true
                    if (!result.debt_item) {
                        await this.finishRegistration()
                        return
                    }
                    debtItem = result.debt_item
                    this.debtItem = debtItem
                }

                if (this.form.payment_type && this.form.payment_type.method === 'cash') {
                    await this.finishRegistration()
                    return
                }

                const invoice = await this.createInvoice(debtItem)
                if (!invoice || invoice.invoiceId === undefined) {
                    this.paymentErrors.push('Не удалось создать счёт для оплаты.')
                    return
                }

                const sum = debtItem.full_sum || debtItem.sum_full || { value: debtItem.sum, currency: 'RUB' }
                atmosPopupHandedOff = true
                const paid = await this.pay(
                    invoice.invoiceId,
                    sum.value,
                    sum.currency,
                    invoice.paymentLink ? { paymentLink: invoice.paymentLink } : invoice.JsonData,
                    atmosPopup
                )
                if (paid === 'redirect') {
                    return
                }
                if (!paid) {
                    if (!this.atmosWait.active) {
                        this.paymentErrors.push('Оплата не прошла. Попробуйте ещё раз.')
                    }
                    return
                }

                await this.finishRegistration()
            } catch (e) {
                const errData = e.response && e.response.data
                const msg = (errData && errData.message)
                    || (Array.isArray(errData) ? errData.join(', ') : null)
                    || 'Ошибка при оплате'
                this.paymentErrors.push(msg)
            } finally {
                if (atmosPopup && !atmosPopupHandedOff) {
                    try {
                        atmosPopup.close()
                    } catch (e) {
                        console.log('failed to close unused atmos tab', e)
                    }
                }
                this.paymentLoading = false
            }
        },
        async finishRegistration() {
            this.stopTimer()
            if (this.showProfileTab) {
                this.activeTab = 'profile'
            } else {
                this.$emit('registered', 'Вы успешно записаны!')
            }
        },

        // ── Close confirmation ───────────────────────────────────────────
        requestClose() {
            if (this.activeTab === 'payment' || this.activeTab === 'profile') {
                this.showCloseConfirm = true
            } else {
                this.$emit('close')
            }
        },
        confirmClose() {
            this.showCloseConfirm = false
            this.$emit('close')
        },

        // ── Profile tab ──────────────────────────────────────────────────
        async submitProfile() {
            if (!this.profileForm.name) return
            this.profileLoading = true
            try {
                let bDay = ''
                if (this.profileForm.b_day) {
                    const d = new Date(this.profileForm.b_day)
                    if (!isNaN(d.getTime())) {
                        const yyyy = d.getFullYear()
                        const mm = String(d.getMonth() + 1).padStart(2, '0')
                        const dd = String(d.getDate()).padStart(2, '0')
                        bDay = `${yyyy}-${mm}-${dd}`
                    }
                }
                await this.$api.user.updateUser({
                    name: this.profileForm.name,
                    surname: this.profileForm.surname,
                    b_day: bDay,
                    sex: this.profileForm.sex,
                })
                await this.$store.dispatch('loadUser')
            } catch (e) { /* ignore */ }
            this.$emit('registered', 'Вы успешно записаны!')
        },
    },
    created() {
        this.atmosWaiter = createAtmosTabWaiter({
            setState: (next) => { this.atmosWait = next }
        })
    },
    mounted() {
        document.body.classList.add('modal-open')
        this.form.email = this.$store.getters.userEmail || ''
        this.loadPaymentData()
    },
    unmounted() {
        this.stopTimer()
        this.atmosWaiter.cancel()
        if (document.querySelectorAll('.modal.show').length === 0) {
            document.body.classList.remove('modal-open')
        }
    },
}
</script>
